export default __webpack_public_path__ + "static/media/img12.e7a999f8.PNG";